import { SxProps } from '@mui/material';

export const LeftBarNavigationTabStyles: SxProps = {
  '&.MuiButtonBase-root': {
    '&.MuiTab-root': {
      border: 'none',
      fontSize: '10px',
      lineHeight: '0.8rem',
      minHeight: 'auto',
      minWidth: '0',
      py: 0.5,
    },
    textAlign: 'center',
  },
  width: '100%',
};
